var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetroFlowBranch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.252,
    height: 10.097,
    viewBox: "0 0 13.252 10.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.362 10.097a1.893 1.893 0 10-1.709-2.695c-1.249-.065-1.674-1-2.284-2.631a10.3 10.3 0 00-.973-2.09h3.246a1.893 1.893 0 100-1.578H3.609a1.894 1.894 0 10-.006 1.59c1.249.065 1.674 1 2.284 2.631.6 1.6 1.35 3.582 3.751 3.66a1.891 1.891 0 001.724 1.113zm1.092-8.2A1.092 1.092 0 1111.362.802a1.092 1.092 0 011.089 1.092zm-11.65 0a1.092 1.092 0 111.092 1.092A1.092 1.092 0 01.804 1.897zm9.458 6.307a1.092 1.092 0 111.1 1.092 1.092 1.092 0 01-1.1-1.092z",
    fill: "#9d9c9c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroFlowBranch);
export default __webpack_public_path__ + "static/media/metro-flow-branch.5dcd0818.svg";
export { ForwardRef as ReactComponent };